goog.provide('el8.appchart.mainFeeds.chartFileUploader');

goog.require('el8.appchart.dialog.chartFiler');
goog.require('el8.appchart.medsHx.main');
goog.require('el8.appchart.refpanel.maint');
goog.require('el8.appchart.refpanel.meds');
goog.require('el8.ptdata.base');
goog.require('el8.service.urls');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.FileUploader');


/**
 * Sets up a FileUploader object to listen for drag-and-drops on the chart itself.
 * Files received this way will either be imported as XmlPatientSummaries
 * (for XML files we think are CCDAs/CCDs/CCRs) or as one of the documents DocMgr
 * supports (via the chartFiler dialog)
 */
el8.appchart.mainFeeds.chartFileUploader = (function() {

    var fileUploader;

    var that = {

        init: function() {
            var $uploadContainer = $('#main-feed-container');

            fileUploader = new el8.uiwidget.FileUploader({
                container: $uploadContainer,
                isImageUpload: true,
                singleFile: true,
                droppableArea: $uploadContainer,
                droppableZoneClass: 'el8UploadDroppableOverlay',
                inputWidth: 0,
                inputHeight: 0,
                customUploadFn: uploadHandler
            });
            fileUploader.show();
        },

        refreshChangedSections: function(changedSections) {
            if (!changedSections) { return; }

            if (_.contains(changedSections, 'problems')) {
                el8.ptdata.ptProblems.load(null, true);
            }
            if (_.contains(changedSections, 'allergies')) {
                el8.ptdata.ptAllergies.load(null, true);
            }
            if (_.contains(changedSections, 'medications')) {
                el8.appchart.refpanel.meds.refreshAll(function() {
                    if (el8.appchart.medsHx.main.isShowing()) {
                        el8.appchart.medsHx.main.clearContents();
                    }
                });
            }
            if (_.contains(changedSections, 'immunizations')) {
                el8.ptdata.ptImmunizations.load(null, true);
                el8.ptdata.ptImmunizationDeclines.load(null, true);
            }
            if (_.contains(changedSections, 'demographics') || _.contains(changedSections, 'demographics_complete')) {
                $.el8_ajax({
                    url: el8.service.urls.get('patientDemographics', [el8.ptdata.currPatient.getId()]),
                    type: 'GET',
                    success: function(data) {
                        el8.ptdata.currPatient.populate(data);
                        el8.appchart.refpanel.demog.triggerRender();
                        el8.appchart.refpanel.maint.render(true);
                    }
                });
            }
            if (_.contains(changedSections, 'history_items')) {
                el8.ptdata.historyItems.loadAll();
            }
        },

        hide: function() {
            fileUploader.hide();
        },
        show: function() {
            fileUploader.show();
        }

    };

    function uploadHandler(files) {
        if (files.length > 1) {
            el8.uiwidget.alert('Please drag and drop one file at a time into the chart. ' +
                'For bulk uploads, use the Document Manger in Practice Home.');
            return;
        }

        var file = files[0];
        if (!file) { return; }

        if (file.type.toLowerCase().endswith('xml') || file.name.toLowerCase().endswith('.xml')) {
            uploadXmlFile(file);
        } else {
            uploadOtherFile(file);
        }
    }

    function uploadXmlFile(file) {
        el8.appservice.notifier.notify('Processing patient summary document...');

        var fd = new FormData();
        fd.append('file', file);

        $.el8_longPoll({
            url: el8.service.urls.get('uploadXmlSummary'),
            data: fd,
            isFileUpload: true,
            success: updateImportedData,
            error: function(data) {
                el8.appservice.notifier.clear();
                if (data.status === 415) {
                    el8.uiwidget.alert('Only Clinical Document XML (C-CDAs, CCDs, etc.) can be imported from the chart. ' +
                        'Upload reports, visit notes, etc., from Practice Home.');
                } else {
                    el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                }
            }
        });
    }

    function uploadOtherFile(file) {
        el8.appchart.dialog.chartFiler.show({
            file: file,
            callbackFn: updateImportedData
        });
    }

    /**
     * @param {Record<string, any> | undefined} serverResponse 
     * @returns 
     */
    function updateImportedData(serverResponse) {
        if (serverResponse == undefined) return;
        
        if (serverResponse.xml_summary) {
            el8.ptdata.xmlSummaries.create(serverResponse.xml_summary);
            el8.appservice.notifier.notify('Patient summary created.');
        } else if (serverResponse.report) {
            el8.ptdata.reports.create(serverResponse.report);
            el8.appservice.notifier.notify('Report created.');
        } else if (serverResponse.nonvisit_note) {
            el8.ptdata.nonvisitNotes.create(serverResponse.nonvisit_note);
            el8.appservice.notifier.notify('Non-visit note created.');
        } else if (serverResponse.visit_note) {
            el8.ptdata.visitNotes.create(serverResponse.visit_note);
            el8.appservice.notifier.notify('Visit note created.');
        }

        that.refreshChangedSections(serverResponse.changed_sections);
    }

    return that;

})();
